import React, { useCallback } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getProductUrl } from "../../../../../../../../../utils/product";
import { useSelector } from "react-redux";
import { getOriginalSize } from "../../../../../../../../utils/sensor";

const ProductNormalSize = props =>{
    useStyles(classes);
    const global = useSelector(state => state.global)
    const { productHooks } = props;
    const { selectedProduct, selectedVariant, selectVariant } = productHooks;
    let arr = [];
    const history = useHistory();

    const getDescription = useCallback(desc => {
        return desc?.replace(/:[\w|\d|\-|(|)|\.]+;/g, function (value) { return '<span style="color:#999;margin-right: 5px;">' + value + ' </span>' })
    }, []);

    const isEnabled = v => {
        if (!v) return true
        return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
    }

    const changeVariant = (variant) => {
        selectVariant(variant?.id)
        if (!isEnabled(variant)) {
            enabledShowEvent(variant)
        }
    }

    const enabledShowEvent = variant => {
        let flag = arr.find(item => item === variant?.id)
        if (!flag) {
            arr.push(variant?.id);
        }
    }

    const bigOrSmallEvent = (item) =>{
        let variantSize = selectedVariant?.size ?? null;

		if(window.GeekoSensors){
			window.GeekoSensors.Track('ELClick', {
				clicks:"ProductSize",
				size: getOriginalSize(variantSize),
				product_sku:selectedProduct?.parentSku,
				related_sku:item?.parentSku
			})
		}

        history.push(getProductUrl(item?.productId, selectedProduct?.name))
    }

    const getSizeLabel = size => {
        const countries = selectedProduct?.sizeChart2?.countryAndSizesList?.[0]?.map(c => c.country)
        const sizeDefaultCountry = countries?.find(c => c === global?.sizeDefaultCountry) || selectedProduct?.sizeChart2?.defaultCountry
        const sizes = selectedProduct?.sizeChart2?.countryAndSizesList?.find?.(s => s[0]?.size === size)
        if(sizes?.length > 0){
            return sizes?.find(s => s.country === sizeDefaultCountry)?.size || size
        }
        return size
    }

    return <React.Fragment>
        <div className={classes.Content}>
            {
                selectedProduct?.variants?.length > 0 && <ul className={classes.SizeUl}>
                    {
                        selectedProduct?.associatedSizeProduct?.bigOrSmall === 0 && <li>
                            <button className={`${classes.Item}`} onClick={() =>bigOrSmallEvent(selectedProduct.associatedSizeProduct)}>
                                <span>{selectedProduct.associatedSizeProduct?.title}</span>
                                <span className={classes.BigOrSmallIcon}></span>
                            </button>
                        </li>
                        
                    }

                    {
                        selectedProduct?.variants.map((variant,index) =>{
                            return <li key={variant.id+index}>
                                <button 
                                    className={`${classes.Item} ${variant?.id === selectedVariant?.id?classes.Active:""} ${!isEnabled(variant)?classes.Disabled:""}`}
                                    onClick={()=>changeVariant(variant)}
                                >{getSizeLabel(variant?.size)}</button>
                            </li>
                        })
                    }

                {
                    selectedProduct?.associatedSizeProduct?.bigOrSmall === 1 && <li>
                        <button className={`${classes.Item}`} onClick={() =>bigOrSmallEvent(selectedProduct.associatedSizeProduct)}>
                            <span>{selectedProduct.associatedSizeProduct?.title}</span>
                            <span className={classes.BigOrSmallIcon}></span>
                        </button>
                    </li>
                }
                </ul>
            }
        </div>

        {
            selectedVariant?.description && <div className={classes.Description}>
                <div className={classes.Title}><FormattedMessage id="product_measurements" defaultMessage="Product Measurements" /></div>
                <span dangerouslySetInnerHTML={{ __html: getDescription(selectedVariant?.description) }} className={classes.XpSizeTip}></span>
            </div>
        }
    </React.Fragment>
}

export default ProductNormalSize;